export { cardVariables as cardFooterVariables } from './cardVariables';
